import { InfoUpgradeCurrentPackage } from "/app/libraries/arcana/src/blocks/Popup/Templates/index.ts"

import { useUnit } from 'effector-react'
import {
  $playerSubscriptionLimitationsQualityTranslations,
  $playerSubscriptionLimitationsTranslations,
} from '../translations'
import { upgradeCurrentPackageWidgetModel } from '../UpgradeCurrentPackageWidget'
import * as model from './model'

interface InfoUpgradeCurrentPackageParams {
  smallPlayer?: boolean
  isRewound?: boolean
}

export const InfoUpgradeCurrentPackageWidget = ({
  smallPlayer,
  isRewound,
}: InfoUpgradeCurrentPackageParams) => {
  const playerSubscriptionLimitationsTranslations = useUnit(
    $playerSubscriptionLimitationsTranslations
  )
  const qualityTranslations = useUnit(
    $playerSubscriptionLimitationsQualityTranslations
  )

  const showWidget = useUnit(model.$showInfoUpgradePackageWidget)
  const showUpgradePackageWidget = useUnit(
    upgradeCurrentPackageWidgetModel.$showUpgradePackageWidget
  )
  const minAvailableQuality = useUnit(model.$minAvailableQuality)

  if (!showWidget || showUpgradePackageWidget || !minAvailableQuality) {
    return null
  }

  const qualityTranslationsWithQuality = qualityTranslations(
    String(minAvailableQuality)
  )

  const description = isRewound
    ? qualityTranslationsWithQuality.rewind_one_quality_available
    : qualityTranslationsWithQuality.no_allowed_quality_available

  return (
    <InfoUpgradeCurrentPackage
      title={
        playerSubscriptionLimitationsTranslations.subscription_upgrade_required_title
      }
      description={description}
      smallPlayer={smallPlayer}
    />
  )
}
